import { render } from "./StarsComp_.vue?vue&type=template&id=6a20dfe2&scoped=true"
import script from "./StarsComp_.vue?vue&type=script&lang=js"
export * from "./StarsComp_.vue?vue&type=script&lang=js"

import "./StarsComp_.vue?vue&type=style&index=0&id=6a20dfe2&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a20dfe2"]])

export default __exports__